export default __webpack_public_path__ + "static/media/customer07.032af84d.jpg";